import * as classNames from 'classnames'
import * as React from 'react'
import { IOrgObj } from '../../../../types'
import UIMessages from '../../../../utils/ui-messages'
import OrganizationInfoForm from './OrganizationInfoForm'
import FloatingForm from 'src/components/ui/form/FloatingForm'

interface IOrganizationInfoPaneProps {
  currentStep: number
  isSaved: boolean
  isSaving: boolean
  organization: IOrgObj
  orgId: string
  isEdit?: boolean
  isCompleted: boolean
  onCompleteStep: (step: number) => void
  onSaveOrganizationInfo: (organization: IOrgObj) => Promise<any>
  showMessage: (error: string, isError: boolean) => void
}

class OrganizationInfoPane extends React.Component<IOrganizationInfoPaneProps> {
  public render() {
    const {
      currentStep,
      isSaved,
      isSaving,
      organization,
      onCompleteStep,
      onSaveOrganizationInfo,
      showMessage
    } = this.props

    const bodyStyle = classNames(
      { 'pointer-events-auto opacity1': !isSaving },
      { 'pointer-events-none opacity04': isSaving }
    )

    return (
      <section>
        <div className={`${bodyStyle}`}>
          <OrganizationInfoForm
            currentStep={currentStep}
            isSaved={isSaved}
            isEdit={this.props.isEdit}
            orgId={this.props.orgId}
            isCompleted={this.props.isCompleted}
            organization={organization}
            onCompleteStep={onCompleteStep}
            onSaveOrganizationInfo={onSaveOrganizationInfo}
            showMessage={showMessage}
          />
        </div>
      </section>
    )
  }
}

export default OrganizationInfoPane



// WEBPACK FOOTER //
// ./src/components/organizations/create/organizationinfo/OrganizationInfo.tsx